/**
 * @description Loads some javascript on demand
 * @param {Object} attrs - attributes allowed on script tags, for inline scripts use 'body'
 * @example
 * // add an inline script
 * loadScript({ body: 'function foo() { ... }'});
 *
 * // fetch some javascript from the network
 * loadScript({
 *  src: '/javascript/lives/here.js',
 *  onload: () => console.log('done!'),
 *  onerror: () => console.log('oops!'),
 * });
 */
var loadScript = function loadScript() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var script = document.createElement('script');
  if (attrs.body && attrs.src) throw new Error('cannot set both body and src, use body for inline scripts and src for network retrieved scripts');
  if (!attrs.body && !attrs.src) throw new Error('invalid script, inline scripts require body and network retrieved scripts require a source url');
  script.type = 'text/javascript';
  Object.keys(attrs).forEach(function (attrKey) {
    script[attrKey === 'body' ? 'innerHTML' : attrKey] = attrs[attrKey];
  });
  document.head.appendChild(script);
};

export default loadScript;